module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_7_5.51e5423f.png";